import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
//import overlayFactory from "react-bootstrap-table2-overlay";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import {
  getBannerSettingService,
  postBannerSettingService,
  publishBanner,
  revokeBanner,
  downloadBanner,
  deleteBanner,
  editBanner,
} from "app/services/bannerSettingService";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { Helmet } from "react-helmet";
import { AiFillEye, AiFillEdit } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import swal from "sweetalert2";
import { NotificationManager } from "react-notifications";
import { Formik } from "formik";
import * as yup from "yup";
import Tooltip from "rc-tooltip";

import config from "config.json";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import usePagePermission from "app/hooks/usePagePermission";
import HandyScroll from "app/common/Scroll";
import { RenderSelectInput } from "app/common/renderInput";

const { dateTimeFormat } = config;

const BannerSetting = () => {
  const { canAdd, canEdit, canDelete, canView } = usePagePermission();
  // console.log({ canAdd, canEdit, canDelete });
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);

  const [showBannerPreview, setShowBannerPreview] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [bannerInformation, setBannerInformation] = useState({
    bannerId: 0,
    bannerName: "",
    bannerDescription: "",
    bannerFile: undefined,
  });

  const openModal = () => setShowPopup(true);

  const closeModal = () => {
    setShowPopup(false);
    setBannerInformation({
      bannerId: 0,
      bannerName: "",
      bannerDescription: "",
      bannerFile: undefined,
    });
  };

  const dateFormatter = (cell, row) => {
    if (cell) {
      return moment(cell).format(dateTimeFormat);
    }
  };

  const onPreviewBanner = async (row) => {
    const result = await downloadBanner(row.id);
    const url = window.URL.createObjectURL(new Blob([result.data]));
    setShowBannerPreview(true);
    setPreviewImage(url);
  };

  const onDeleteBanner = async (row) => {
    swal
      .fire({
        title: `Are you sure you want to Delete this banner?`,
        icon: "warning",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then(async (result) => {
        if (result.value) {
          const result = await deleteBanner(row.id);
          NotificationManager.error(
            "Banner  deleted successfully",
            "success",
            5000
          );
          loadBannerService();
        } else {
          swal.fire({
            title: "Cancelled!",
            text: "Permission denied.",
            type: "error",
            icon: "error",
            timer: 1500,
          });
        }
      });
  };

  const onEditBanner = async (row) => {
    setBannerInformation({
      bannerId: row.id,
      bannerName: row.bannerName,
      bannerDescription: row.bannerDescription,
      bannerFile: undefined,
      merchantThemeType: row.merchantThemeType
    });
    setShowPopup(true);
  };

  const updateBannerStatus = async (row) => {
    swal
      .fire({
        title: `Are you sure you want to ${row.isActive ? "inactive" : "active"
          } the banner?`,
        icon: "warning",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
      })
      .then(async (result) => {
        if (result.value) {
          if (row.isActive) {
            const result = await revokeBanner(row.id);
            if (result.status == "Success") {
              NotificationManager.warning(result.message, "Success", 5000);
            } else {
              NotificationManager.error(result.message, "error", 5000);
            }
            // NotificationManager.warning(
            //   "Banner inactive successfully",
            //   "Success",
            //   5000
            // );
          } else {
            const result = await publishBanner(row.id);
            if (result.status == "Success") {
              NotificationManager.success(result.message, "Success", 5000);
            } else {
              NotificationManager.error(result.message, "error", 5000);
            }
            // NotificationManager.success(
            //   "Banner activated successfully",
            //   "Success",
            //   5000
            // );
          }
          loadBannerService();
        } else {
          swal.fire({
            title: "Cancelled!",
            text: "Permission denied.",
            type: "error",
            icon: "error",
            timer: 1500,
          });
        }
      });
  };

  const actionFormatter = (cell, row) => {
    return (
      <>
        <Row>
          <Col>
            {" "}
            {canEdit && (
              <Tooltip
                placement="left"
                overlay={row.isActive ? "Click to Inactive" : "Click to Active"}
              >
                <span className="col-sm-12">
                  <Form.Check
                    type="switch"
                    id={`custom-switch${row.id}`}
                    checked={row.isActive}
                    onChange={() => updateBannerStatus(row)}
                    className="mt-1 me-2"
                  />
                </span>
              </Tooltip>
            )}
          </Col>
          <Col>
            {" "}
            <span className="col-sm-12">
              {canView ? (
                <Tooltip placement="top" overlay="Preview">
                  <AiFillEye
                    onClick={() => onPreviewBanner(row)}
                    size="1.5em"
                    color="purple"
                    className="ms-2 mt-1"
                  ></AiFillEye>
                </Tooltip>
              ) : (
                <Tooltip placement="top" overlay="Preview disabled">
                  <AiFillEye
                    // onClick={() => onPreviewBanner(row)}
                    size="1.5em"
                    color="#a66ea6"
                    className="ms-2 mt-1"
                  ></AiFillEye>
                </Tooltip>
              )}
            </span>
          </Col>
          <Col>
            {" "}
            <span className="col-sm-12">
              {canDelete ? (
                <Tooltip placement="top" overlay="Delete">
                  <MdDelete
                    onClick={() => onDeleteBanner(row)}
                    size={16}
                    color="red"
                    variant="danger"
                    className="mx-4"
                  />
                </Tooltip>
              ) : (
                <Tooltip placement="top" overlay="Delete disabled">
                  <MdDelete
                    // style={{ cursor: "default" }}
                    // onClick={() => onDeleteBanner(row)}
                    size={16}
                    color="FF7171"
                    variant="danger"
                    className="mx-4"
                  />
                </Tooltip>
              )}
            </span>
          </Col>
          <Col>
            <span className="col-sm-12">
              {canEdit ? (
                <Tooltip placement="top" overlay="Modify">
                  <AiFillEdit
                    onClick={() => onEditBanner(row)}
                    size={16}
                    color="black"
                  ></AiFillEdit>
                </Tooltip>
              ) : (
                <Tooltip placement="top" overlay="Modify disabled">
                  <AiFillEdit
                    // onClick={() => onEditBanner(row)}
                    size={16}
                    color="gray"
                  ></AiFillEdit>
                </Tooltip>
              )}
            </span>
          </Col>
        </Row>
      </>
    );
  };

  const bannerNameFormatter = (cell, row) => {
    return (
      <>
        <span
          style={{
            float: "left",
            backgroundColor: row.isActive ? "green" : "gray",
            width: "10px",
            height: "10px",
            borderRadius: "10px",
          }}
        ></span>
        <span>{row.bannerName}</span>
      </>
    );
  };
  const bannerTypeFormatter = (cell, row) => {

    const formatted = cell?.replace(/_/g, " ");
    console.log(formatted); // "LOGIN BANNER"

    return formatted;
  };
  const saveBannerInformation = async (values) => {
    let formData = new FormData();
    formData.append("BannerName", values.bannerName);
    formData.append("BannerDescription", values.bannerDescription);
    formData.append("BannerFile", values.bannerFile);
    formData.append("merchantThemeType", values.merchantThemeType);
    if (values.bannerId > 0) {
      // message

      const result = await editBanner(values.bannerId, formData);
      if (result.status == "Success") {
        NotificationManager.success(result.message, "Success", 5000);
      } else {
        NotificationManager.error(result.message, "error", 5000);
      }
    } else {
      const result = await postBannerSettingService(formData);
      if (result.status == "Success") {
        NotificationManager.success(result.message, "Success", 5000);
      } else {
        NotificationManager.error(result.message, "error", 5000);
      }
      // NotificationManager.success(
      //   " Banner added successfully ",
      //   "Success",
      //   5000
      // );
    }
    loadBannerService();
    closeModal();
  };

  const columns = [
    {
      dataField: "bannerName",
      text: "Banner Name",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: bannerNameFormatter,
    },
    {
      dataField: "bannerDescription",
      text: "Banner Description",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "merchantThemeType",
      text: "Banner Type",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: bannerTypeFormatter,
    },
    {
      dataField: "updatedOn",
      text: "Last Updated",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const loadBannerService = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });

    const response = await getBannerSettingService(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
  };

  useEffect(() => {
    loadBannerService();
  }, [page, sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${isSelect ? "btn-primary" : "btn-secondary"
                }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const FILE_SIZE = 50000000;
  const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/gif",
  ];
  const validationSchema = yup.object().shape({
    bannerName: yup.string().trim().required("Banner Name is required."),
    bannerDescription: yup.string().required("Banner Description is required."),
    bannerFile: yup.mixed().when("bannerId", {
      is: "0",
      then: yup
        .mixed()
        .required("Banner is required.")
        .test("FILE_SIZE", "Uploaded file is too big.", (value) => {
          const file = document.getElementById("bannerFile").files[0];
          return !file || (file && file.size <= FILE_SIZE);
        })
        .test(
          "FILE_FORMAT",
          "Uploaded file has unsupported format.",
          (value) => {
            const file = document.getElementById("bannerFile").files[0];
            return !file || (file && SUPPORTED_FORMATS.includes(file.type));
          }
        ),
      otherwise: yup
        .mixed()
        .nullable()
        .notRequired()
        .test("FILE_SIZE", "Uploaded file is too big.", (value) => {
          const file = document.getElementById("bannerFile").files[0];
          return !file || (file && file.size <= FILE_SIZE);
        })
        .test(
          "FILE_FORMAT",
          "Uploaded file has unsupported format.",
          (value) => {
            const file = document.getElementById("bannerFile").files[0];
            return !file || (file && SUPPORTED_FORMATS.includes(file.type));
          }
        ),
    }),
    bannerId: yup.string().optional(),
    merchantThemeType: yup.string().trim().required("Banner type is required."),
  });

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const [bannerTypeOptions] = useState([
    { value: "OFFER_BANNER", label: "Offer" },
    { value: "LOGIN_BANNER", label: "Login" },

  ]);
  return (
    <>
      {canAdd && (
        <Button
          onClick={openModal}
          className="btn btn-primary btn-md float-end"
        >
          Add Banner
        </Button>
      )}
      {/*----------------- Add & update modal start from here -------------*/}
      <Modal show={showPopup} onHide={closeModal}>
        <Formik
          initialValues={
            bannerInformation.bannerId
              ? bannerInformation
              : {
                bannerId: 0,
                bannerName: "",
                bannerDescription: "",
                bannerFile: undefined,
                merchantThemeType: ""
              }
          }
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={saveBannerInformation}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} className="position-relative">
              <Modal.Header>
                <Modal.Title>Select Your Favorite Banner </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="form-group">
                  <label htmlFor="bannerName">Banner Name</label>
                  <input
                    type="text"
                    name="bannerName"
                    id="bannerName"
                    value={values.bannerName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="form-control"
                    placeholder="Banner Name"
                  />
                  {touched.bannerName && errors.bannerName && (
                    <small className="form-text text-danger">
                      {errors.bannerName}
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="bannerDescription">Banner Description</label>
                  <input
                    type="text"
                    name="bannerDescription"
                    id="bannerDescription"
                    value={values.bannerDescription}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="form-control"
                    placeholder="Banner Description"
                  />
                  {touched.bannerDescription && errors.bannerDescription && (
                    <small className="form-text text-danger">
                      {errors.bannerDescription}
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <Row>
                    <Row>
                      <label htmlFor="bannerFile">Banner Image</label></Row>
                    <Row>
                      <input
                        type="file"
                        id="bannerFile"
                        onChange={(e) => {
                          setFieldValue("bannerFile", e.target.files[0]);
                        }}
                        onBlur={handleBlur}
                        name="bannerFile"
                      /></Row>
                    <Row>
                      {touched.bannerFile && errors.bannerFile && (
                        <small className="form-text text-danger">
                          {errors.bannerFile}
                        </small>
                      )}</Row>
                  </Row>
                </div>
                <div className="form-group">
                  <RenderSelectInput
                    name="merchantThemeType"
                    display="Banner Type"
                    placeholder="Banner Type"
                    value={values.merchantThemeType}
                    error={errors.merchantThemeType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.merchantThemeType}
                    items={bannerTypeOptions}
                    required
                  ></RenderSelectInput>

                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button disabled={isSubmitting} variant="primary" type="submit">
                  {isSubmitting
                    ? "Please wait ..."
                    : values.bannerId > 0
                      ? "Update"
                      : "+ Add"}
                </Button>
                <Button variant="danger" onClick={closeModal}>
                  <div className="text-white">Close</div>
                </Button>
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </Modal>

      {/*```````````````````` Preview Modal start from here ```````````````*/}

      <Modal
        show={showBannerPreview}
        onHide={() => setShowBannerPreview(false)}
      >
        <Modal.Header>
          <Modal.Title>Preview Banner </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={previewImage} alt="Banner Preview" />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowBannerPreview(false)}>
            <div className="text-white">Close</div>
          </Button>
        </Modal.Footer>
      </Modal>

      <Helmet>
        <title>Offer Banner Settings</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Offer Banner Settings" }]}
      ></Breadcrumb>

      <div>
        {canView && (
          <HandyScroll>
            <div
              class="spacious-container"
              data-handy-scroll
              style={{ overflow: "auto" }}
            >
              <BootstrapTable
                hover
                remote
                keyField="id"
                data={data}
                columns={
                  // canEdit
                  // ?
                  columns
                  //  : columns.filter((x) => x.text !== "Action")
                }
                //  onTableChange={this.handleTableChange}
                pagination={paginationFactory(paginationOptions)}
                onTableChange={handleTableChange}
                headerClasses="bg-primary text-white"
                bodyClasses="react-bootstrap-table-next-min-height"
                rowStyle={rowStyle}
              />
            </div>
          </HandyScroll>
        )}
      </div>
    </>
  );
};

export default BannerSetting;
